import {makeAdapter} from '@client/make-adapter'
import {Sync} from '@client/sync'
import {WorkflowClient} from '@client/workflow-client'
import {MessageBox} from '@components/message-box'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {
  Action,
  findIdInWorkflow,
  getWorkflowAction,
  Hub,
  Workflow,
  Workflows,
  workflowToConfig
} from 'yougile-model'
import {ActionButton} from '../workflow-components'
import {Props} from './workflow-in-task'

interface ActionItemProps extends Props {
  workflow: Workflow
  actionPath: string[]
}

const isActionAvailable = async (
  action: Action,
  workflow: Workflow,
  task: Hub
): Promise<boolean> => {
  if (!action.when) {
    return true
  }
  const adapter = makeAdapter()
  const taskJson = task.toJSON()

  for (const condition of action.when) {
    if (
      !(await Workflows.checkCondition(condition, {
        task: taskJson,
        workflow,
        adapter
      }))
    ) {
      return false
    }
  }
  return true
}

export const ActionItem = (props: ActionItemProps): JSX.Element => {
  const {workflow, actionPath, taskId} = props
  const task = Sync.getCurrentSandbox().getHub(taskId)
  const id = findIdInWorkflow(workflow.ids, ...actionPath)
  const {action} = getWorkflowAction(workflow, id)
  const [available, setAvailable] = useState(false)

  if (!action) {
    return <div>Error: action not found</div>
  }

  void isActionAvailable(action, workflow, task).then(res => setAvailable(res))
  if (!available) {
    return null
  }

  const submit = async (_text: undefined, inputs: {[id: string]: any}) => {
    const {workflow, taskId} = props
    try {
      await WorkflowClient.runAction({
        workflowId: workflow.id,
        actionId: findIdInWorkflow(workflow.ids, ...actionPath),
        taskId,
        inputs
      })
      MessageBox.show(Lang.msg.workflow.actionDone, 'success')
    } catch (e) {
      MessageBox.show(e.message ?? Lang.msg.error, 'danger')
    }
  }

  return (
    <div key={id} className="mt-8">
      <ActionButton
        action={action}
        workflow={workflow}
        config={workflowToConfig(workflow)}
        onSubmit={submit}
      />
    </div>
  )
}
